/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCornerLeftUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21 21H7l.001-14.656L4.239 9 3 7.808 8 3l5 4.808L11.761 9l-2.76-2.655L9 19h12z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCornerLeftUp as CornerLeftUp };
